const get = () =>
  Promise.resolve([
    "Presentación en salón de clases",
    "Stand o charla en la universidad",
    "Evento por fuera de la universidad",
    "Revistas, televisión, periódico o radio",
    "Facebook",
    "Instagram",
    "LinkedIn",
    "Twitter",
    "Otra red social",
    "Buscadores web",
    "Correo",
    "Amigo",
    "Sitio web",
    "Otro",
  ]);

const placesService = {
  get,
};

export default placesService;
